package fr.frux.feature.map

/**
 * Règle de présence de la bannière de carte (ADR 0030, #529) : seulement quand rien n'occupe le bas
 * de l'écran. Un arbre sélectionné, un groupe de marqueurs ou un panneau (filtres, légende,
 * « Autour de toi ») la retire, la saisie de recherche aussi (clavier et résultats couvrent le bas).
 * Elle revient d'elle-même à la fermeture. Fonction pure : l'éligibilité et l'arbitrage restent au
 * contrôleur publicitaire.
 */
internal fun mapBannerRequested(
    selectedTreeOpen: Boolean,
    markerGroupOpen: Boolean,
    panelOpen: Boolean,
    searchActive: Boolean,
    selectedSiteOpen: Boolean = false,
): Boolean = !selectedTreeOpen && !selectedSiteOpen && !markerGroupOpen && !panelOpen && !searchActive

/** Ce que le slot bas de la carte porte (#529). */
internal enum class MapBottomSlot { GROUP, TREE, SITE, BANNER, NONE }

/**
 * Une seule surface au bas de la carte, priorité descendante : groupe de marqueurs, fiche d'arbre,
 * résumé de lieu, bannière. La fiche d'arbre ou de lieu REMPLACE la bannière dans la même feuille
 * (ADR 0030 : aucune annonce sur une fiche), elles ne coexistent jamais, même si l'arbitrage
 * publicitaire n'a pas encore rendu la claim. Un arbre et un lieu ne sont jamais sélectionnés
 * ensemble : si les deux le sont, l'arbre l'emporte.
 */
internal fun mapBottomSlot(
    markerGroupOpen: Boolean,
    selectedTreeOpen: Boolean,
    selectedSiteOpen: Boolean,
    bannerShowing: Boolean,
): MapBottomSlot =
    when {
        markerGroupOpen -> MapBottomSlot.GROUP
        selectedTreeOpen -> MapBottomSlot.TREE
        selectedSiteOpen -> MapBottomSlot.SITE
        bannerShowing -> MapBottomSlot.BANNER
        else -> MapBottomSlot.NONE
    }
